(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8171],{

/***/ 6777:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pelatihan-mandiri/aksi-nyata/[id]",
      function () {
        return __webpack_require__(1717);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 83759:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ru": function() { return /* binding */ useGetPublicAksiNyata; },
/* harmony export */   "UR": function() { return /* binding */ useGetAksiNyataList; },
/* harmony export */   "V0": function() { return /* binding */ useGetAksiNyataFeedback; },
/* harmony export */   "yc": function() { return /* binding */ usePostAksiNyataFeedback; }
/* harmony export */ });
/* unused harmony exports FeedbackUnauthorized, useGetFeedbackAuthorizeStatus */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28668);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25171);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70655);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88767);
/* harmony import */ var utils_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71529);
/* harmony import */ var utils_customError__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97512);








var FeedbackUnauthorized = /*#__PURE__*/ function(CustomError) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(FeedbackUnauthorized, CustomError);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(FeedbackUnauthorized);
    function FeedbackUnauthorized(apiPath, originalError) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, FeedbackUnauthorized);
        var title = "Tidak Dapat Ditampilkan";
        var description = "Anda tidak memiliki akses untuk melihat Aksi Nyata milik guru lain.";
        return _super.call(this, {
            title: title,
            description: description,
            apiPath: apiPath,
            originalError: originalError
        });
    }
    return FeedbackUnauthorized;
}(utils_customError__WEBPACK_IMPORTED_MODULE_5__/* .CustomError */ .sH);
function useGetFeedbackAuthorizeStatus() {
    var isEnabled = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    return useQueryApi("/microlearnings/feedbacks/authorized", {
        queryConfig: {
            enabled: isEnabled,
            useErrorBoundary: false
        }
    });
}
function useGetAksiNyataList(updatedAtUnix) {
    var limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10;
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useInfiniteQuery)([
        "aksinyata-infinite-query"
    ], function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(param) {
            var _pageParam, pageParam;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                _pageParam = param.pageParam, pageParam = _pageParam === void 0 ? {
                    updatedAtUnix: updatedAtUnix,
                    limit: limit
                } : _pageParam;
                return [
                    2,
                    (0,utils_api__WEBPACK_IMPORTED_MODULE_1__/* .api */ .hi)("/microlearnings/aksi-nyata-validations", {
                        params: pageParam
                    })
                ];
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), {
        select: function(data) {
            return {
                pages: data.pages.map(function(page) {
                    return {
                        data: page.data.map(function(param) {
                            var id = param.id, title = param.title, creator = param.creator, topicId = param.topicId, topicName = param.topicName;
                            return {
                                id: id,
                                title: title,
                                creator: creator,
                                topicId: topicId,
                                topicName: topicName
                            };
                        }),
                        meta: {}
                    };
                }),
                pageParams: data.pageParams
            };
        },
        getNextPageParam: function(lastPage) {
            return lastPage.data.length > 0 ? {
                updatedAtUnix: lastPage.data[lastPage.data.length - 1].updatedAtUnix,
                limit: limit
            } : undefined;
        }
    });
}
function useGetPublicAksiNyata(aksiNyataId) {
    var enabled = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_1__/* .useQueryApi */ .Zy)("/microlearnings/aksi-nyata/".concat(aksiNyataId), {
        queryConfig: {
            enabled: !!aksiNyataId && enabled
        },
        errorHandlerFn: function(status, path, error) {
            (0,utils_api__WEBPACK_IMPORTED_MODULE_1__/* .handleCommonErrors */ .CI)(status !== null && status !== void 0 ? status : 500, path, error);
        }
    });
}
function useGetAksiNyataFeedback(aksiNyataId) {
    var isEnabled = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_1__/* .useQueryApi */ .Zy)("/microlearnings/aksi-nyata/".concat(aksiNyataId, "/feedbacks"), {
        queryConfig: {
            enabled: !!aksiNyataId && isEnabled,
            useErrorBoundary: false
        },
        errorHandlerFn: function(status, path, error) {
            if (status === 401) {
                throw new FeedbackUnauthorized(path, error);
            } else {
                (0,utils_api__WEBPACK_IMPORTED_MODULE_1__/* .handleCommonErrors */ .CI)(status, path, error);
            }
        }
    });
}
function usePostAksiNyataFeedback(aksiNyataId, opts) {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_1__/* .useMutationApi */ .fy)("/microlearnings/aksi-nyata/".concat(aksiNyataId, "/feedbacks"), {
        mutationConfig: opts,
        axiosConfig: {
            method: "POST"
        }
    });
}


/***/ }),

/***/ 14644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cz": function() { return /* binding */ useGetTopicAksiNyataSession; },
/* harmony export */   "Ht": function() { return /* binding */ useTriggerGenerateCertificatePdf; },
/* harmony export */   "Lr": function() { return /* binding */ useTopicProgress; },
/* harmony export */   "MD": function() { return /* binding */ useTopicNewest; },
/* harmony export */   "Sw": function() { return /* binding */ useGetTopicDetail; },
/* harmony export */   "TA": function() { return /* binding */ useGetRelevanceTopic; },
/* harmony export */   "Ti": function() { return /* binding */ usePostAksiNyataAppeal; },
/* harmony export */   "W0": function() { return /* binding */ usePostAksiNyata; },
/* harmony export */   "XI": function() { return /* binding */ useGetTopicList; },
/* harmony export */   "bJ": function() { return /* binding */ useGetCertificate; },
/* harmony export */   "bt": function() { return /* binding */ useGetAksiNyataRevision; },
/* harmony export */   "gb": function() { return /* binding */ useGetTopicAksiNyataOptions; },
/* harmony export */   "l4": function() { return /* binding */ usePostCertificate; },
/* harmony export */   "oq": function() { return /* binding */ useTopicRecommendation; },
/* harmony export */   "w3": function() { return /* binding */ JenjangUnmatched; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28668);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25171);
/* harmony import */ var utils_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71529);
/* harmony import */ var utils_customError__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97512);






var JenjangUnmatched = /*#__PURE__*/ function(CustomError) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(JenjangUnmatched, CustomError);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(JenjangUnmatched);
    function JenjangUnmatched(apiPath, originalError) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, JenjangUnmatched);
        var title = "Jenjang tidak sesuai";
        var description = "Topik yang anda akses tidak sesuai dengan jenjang akun anda.";
        return _super.call(this, {
            title: title,
            description: description,
            apiPath: apiPath,
            originalError: originalError
        });
    }
    return JenjangUnmatched;
}(utils_customError__WEBPACK_IMPORTED_MODULE_4__/* .CustomError */ .sH);
function useGetTopicList() {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("/microlearnings/topics", {
        errorHandlerFn: function(status, path, error) {
            (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .handleCommonErrors */ .CI)(status !== null && status !== void 0 ? status : 500, path, error);
        }
    });
}
function useGetTopicDetail(topicId) {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("/microlearnings/topics/".concat(topicId), {
        queryConfig: {
            enabled: !!topicId
        },
        errorHandlerFn: function(status, path, error, errorResponse) {
            var ref, ref1, ref2, ref3;
            if (status === 400 && !!((ref1 = (ref = errorResponse.data) === null || ref === void 0 ? void 0 : ref.errors[0]) === null || ref1 === void 0 ? void 0 : ref1.code) && ((ref3 = (ref2 = errorResponse.data) === null || ref2 === void 0 ? void 0 : ref2.errors[0]) === null || ref3 === void 0 ? void 0 : ref3.code) === "08-118") {
                throw new JenjangUnmatched(path, error);
            } else {
                (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .handleCommonErrors */ .CI)(status !== null && status !== void 0 ? status : 500, path, error);
            }
        }
    });
}
function useGetTopicAksiNyataOptions(topicId, enabled) {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("/microlearnings/topics/".concat(topicId, "/aksi-nyata-options"), {
        queryConfig: {
            enabled: !!topicId && enabled
        }
    });
}
function useGetTopicAksiNyataSession(topicId, enabled) {
    var data = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("/microlearnings/topics/".concat(topicId, "/aksi-nyata"), {
        queryConfig: {
            enabled: !!topicId && enabled,
            useErrorBoundary: false
        },
        axiosConfig: {
            data: data
        }
    });
}
function usePostAksiNyata(topicId, method, opts) {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useMutationApi */ .fy)("/microlearnings/topics/".concat(topicId, "/aksi-nyata"), {
        mutationConfig: opts,
        axiosConfig: {
            method: method
        }
    });
}
function useGetRelevanceTopic(topicId) {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("/microlearnings/topics/".concat(topicId, "/relevances"), {
        queryConfig: {
            useErrorBoundary: false
        }
    });
}
function useGetAksiNyataRevision(topicId, enabled) {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("/microlearnings/topics/".concat(topicId, "/aksi-nyata/revision"), {
        queryConfig: {
            enabled: !!topicId && enabled,
            useErrorBoundary: false
        }
    });
}
function usePostCertificate(topicId, method, opts) {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useMutationApi */ .fy)("/microlearnings/topics/".concat(topicId, "/certificate"), {
        mutationConfig: opts,
        axiosConfig: {
            method: method
        }
    });
}
function useGetCertificate(param) {
    var enabled = param.enabled, errorHandler = param.errorHandler, refetchInterval = param.refetchInterval, topicId = param.topicId;
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("/microlearnings/topics/".concat(topicId, "/certificate"), {
        axiosConfig: {
            method: "GET"
        },
        queryConfig: {
            enabled: !!topicId && enabled,
            useErrorBoundary: false,
            refetchInterval: refetchInterval
        },
        errorHandlerFn: function(_status, _path, error, errorResponse) {
            var errorCode = errorResponse.data.errors[0].code;
            errorHandler === null || errorHandler === void 0 ? void 0 : errorHandler(errorCode, error);
        }
    });
}
function useTriggerGenerateCertificatePdf(topicId, opts) {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useMutationApi */ .fy)("/microlearnings/topics/".concat(topicId, "/certificate/rerender"), {
        mutationConfig: opts,
        axiosConfig: {
            method: "POST"
        }
    });
}
function usePostAksiNyataAppeal(topicId, opts) {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useMutationApi */ .fy)("/microlearnings/topics/".concat(topicId, "/aksi-nyata/appeal"), {
        mutationConfig: opts,
        axiosConfig: {
            method: "POST"
        }
    });
}
function useTopicNewest() {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("/microlearnings/topic-recommendation", {
        queryConfig: {
            useErrorBoundary: false
        }
    });
}
function useTopicRecommendation() {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("/microlearnings/section-page", {
        queryConfig: {
            useErrorBoundary: false
        }
    });
}
function useTopicProgress() {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("/microlearnings/topics/progress", {
        queryConfig: {
            useErrorBoundary: false
        }
    });
}


/***/ }),

/***/ 55231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ Anchor; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var utils_androidHandler__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84494);






var Anchor = function(props) {
    var href = props.href, children = props.children, linkProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, [
        "href",
        "children"
    ]);
    var androidHandler = (0,utils_androidHandler__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)();
    var isAndroid = androidHandler.enabled;
    if (isAndroid) {
        // if children tag is anchor tag, return it
        if (children && typeof children === "object") {
            var child = children;
            if (child.type === "a") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: children
                });
            }
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            href: href
        }, linkProps), {
            children: children
        }));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        href: href
    }, linkProps), {
        children: children
    }));
};


/***/ }),

/***/ 72351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S_": function() { return /* binding */ DesktopLayout; },
/* harmony export */   "nc": function() { return /* binding */ WithLayoutListener; }
/* harmony export */ });
/* unused harmony exports useDesktopSubmenuHook, WithDesktopLayout */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70655);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _wartek_id_header_bar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89140);
/* harmony import */ var _wartek_id_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21958);
/* harmony import */ var _wartek_id_text__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(89004);








var PELATIHAN_MANDIRI_PATH = "/pelatihan-mandiri";
var SUB_MENU_TEMPLATE = {
    FOR_YOU: next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
        return Promise.all(/* import() */[__webpack_require__.e(4842), __webpack_require__.e(1547), __webpack_require__.e(7882), __webpack_require__.e(8085), __webpack_require__.e(6315), __webpack_require__.e(9583)]).then(__webpack_require__.bind(__webpack_require__, 86315));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(86315)
                ];
            }
        },
        ssr: false
    }),
    TOPIK: next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
        return Promise.all(/* import() */[__webpack_require__.e(1651), __webpack_require__.e(4088), __webpack_require__.e(4842), __webpack_require__.e(7882), __webpack_require__.e(8085), __webpack_require__.e(5888)]).then(__webpack_require__.bind(__webpack_require__, 92629));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(92629)
                ];
            }
        },
        ssr: false
    }),
    AKSI_NYATA: next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
        return Promise.all(/* import() */[__webpack_require__.e(4842), __webpack_require__.e(6683), __webpack_require__.e(7882), __webpack_require__.e(9103), __webpack_require__.e(1317)]).then(__webpack_require__.bind(__webpack_require__, 69103)).then(function(template) {
            return template.AksiNyataList;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(69103)
                ];
            }
        },
        ssr: false
    }),
    MODUL: next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
        return Promise.all(/* import() */[__webpack_require__.e(1651), __webpack_require__.e(9291), __webpack_require__.e(6721), __webpack_require__.e(6426), __webpack_require__.e(6014)]).then(__webpack_require__.bind(__webpack_require__, 17422));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(17422)
                ];
            }
        },
        ssr: false
    })
};
var DesktopLayout = function(param) {
    var children = param.children, submenu = param.submenu;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var pathname = router.pathname, query = router.query;
    // TODO: adjust this
    var sideMenu = [
        {
            label: "Seri Pelatihan",
            icon: "book",
            href: "/pelatihan-mandiri",
            active: pathname === "/pelatihan-mandiri" || pathname.includes("/pelatihan-mandiri/seri-pelatihan") || query.from === "learning-series"
        },
        {
            label: "Topik",
            icon: "topic",
            href: "/pelatihan-mandiri/daftar-topik",
            active: pathname === "/pelatihan-mandiri/daftar-topik" || pathname === "".concat(PELATIHAN_MANDIRI_PATH, "/modul/[modul]") || pathname === "".concat(PELATIHAN_MANDIRI_PATH, "/text/[id]") || pathname === "".concat(PELATIHAN_MANDIRI_PATH, "/video/[id]") || pathname === "".concat(PELATIHAN_MANDIRI_PATH, "/quiz/[id]") || pathname === "".concat(PELATIHAN_MANDIRI_PATH, "/refleksi/[id]") || pathname.includes("/pelatihan-mandiri/topik/[topik]") && query.from !== "learning-series"
        },
        {
            label: "Webinar",
            icon: "live_tv",
            href: "/pelatihan-mandiri/webinar",
            active: pathname.includes("/pelatihan-mandiri/webinar")
        },
        {
            label: "Aksi nyata",
            icon: "batch_prediction",
            href: "/pelatihan-mandiri/daftar-aksi-nyata",
            active: pathname === "/pelatihan-mandiri/daftar-aksi-nyata" || pathname.includes("/pelatihan-mandiri/aksi-nyata")
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col h-screen w-full",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "fixed w-full p-4 flex flex-row items-center bg-white z-20",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_header_bar__WEBPACK_IMPORTED_MODULE_3__/* .HeaderBarLeftAction */ .l8, {
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_icon__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .J, {
                            as: "i",
                            color: "default",
                            children: "arrow_back"
                        }),
                        onClick: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            router.push("/home")
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_header_bar__WEBPACK_IMPORTED_MODULE_3__/* .HeaderBarTitle */ .rF, {
                        children: "Merdeka Mengajar"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-row bg-gray-10 overflow-hidden h-full",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex flex-col w-64 border-r border-gray-200 mt-[80px] px-4",
                        children: sideMenu.map(function(item, index) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-row items-center p-2 mt-4 rounded-lg cursor-pointer hover:bg-gray-5 ".concat(item.active ? "bg-gray-20" : ""),
                                onClick: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    router.push(item.href)
                                                ];
                                            case 1:
                                                _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                }),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_icon__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .J, {
                                        as: "i",
                                        color: item.active ? "informational" : "default",
                                        className: "mr-4",
                                        children: item.icon
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_text__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .x, {
                                        color: item.active ? "primary" : "default",
                                        variant: "heading-sm",
                                        children: item.label
                                    })
                                ]
                            }, "sidemenu-".concat(index));
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "overflow-y-scroll w-[380px]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                            className: "mt-8",
                            children: submenu
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex-1 overflow-y-scroll p-2 max-w-6xl mx-auto md:px-8 lg:px-16",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                            className: "mt-[80px]",
                            children: children && children
                        })
                    })
                ]
            })
        ]
    });
};
var useDesktopSubmenuHook = function(isDesktop) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var pathname = router.pathname;
    var _query = router.query, id = _query.id, from = _query.from, menuId = _query.menuId, topik = _query.topik;
    if (!isDesktop) return null;
    var SubMenuPageMap = [
        {
            path: "".concat(PELATIHAN_MANDIRI_PATH, "/seri-pelatihan/[id]"),
            components: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SUB_MENU_TEMPLATE.FOR_YOU, {
                    isDesktop: true,
                    currentId: id
                })
            }, "seri-pelatihan-dekstop-submenu")
        },
        {
            path: "".concat(PELATIHAN_MANDIRI_PATH, "/topik/[topik]"),
            components: menuId && from === "learning-series" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SUB_MENU_TEMPLATE.FOR_YOU, {
                    isDesktop: true,
                    currentId: menuId
                })
            }, "topik-desktop-submenu") : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SUB_MENU_TEMPLATE.TOPIK, {
                    isDesktop: true,
                    currentId: topik
                })
            }, "topik-desktop-submenu")
        },
        {
            path: "".concat(PELATIHAN_MANDIRI_PATH, "/daftar-aksi-nyata"),
            components: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SUB_MENU_TEMPLATE.AKSI_NYATA, {
                    isDesktop: true
                })
            }, "daftar-aksi-nyata-desktop-submenu")
        },
        {
            path: "".concat(PELATIHAN_MANDIRI_PATH, "/aksi-nyata/[id]"),
            components: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SUB_MENU_TEMPLATE.AKSI_NYATA, {
                    isDesktop: true
                })
            }, "aksi-nyata-desktop-submenu")
        },
        {
            path: [
                "".concat(PELATIHAN_MANDIRI_PATH, "/modul/[modul]"),
                "".concat(PELATIHAN_MANDIRI_PATH, "/text/[id]"),
                "".concat(PELATIHAN_MANDIRI_PATH, "/video/[id]"),
                "".concat(PELATIHAN_MANDIRI_PATH, "/quiz/[id]"),
                "".concat(PELATIHAN_MANDIRI_PATH, "/refleksi/[id]"), 
            ],
            components: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SUB_MENU_TEMPLATE.MODUL, {})
            }, "modul-desktop-submenu")
        }, 
    ];
    var currentSubMenu = SubMenuPageMap.map(function(subMenu) {
        if (typeof subMenu.path === "string") {
            if (pathname.includes(subMenu.path)) {
                return subMenu.components;
            }
        }
        if (Array.isArray(subMenu.path)) {
            if (subMenu.path.some(function(path) {
                return pathname.includes(path);
            })) {
                return subMenu.components;
            }
        }
    });
    return currentSubMenu;
};
var WithDesktopLayout = function(param) {
    var children = param.children;
    var currentSubMenu = useDesktopSubmenuHook(true);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DesktopLayout, {
        submenu: currentSubMenu,
        children: children
    });
};
var WithLayoutListener = function(param) {
    var children = param.children, isDesktop = param.isDesktop;
    if (isDesktop) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WithDesktopLayout, {
            children: children
        });
    }
    return children;
};


/***/ }),

/***/ 91003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ ANDROID_VERSION_MAP; }
/* harmony export */ });
var ANDROID_VERSION_MAP = {
    PELATIHAN_MANDIRI_NATIVE: 13300
};


/***/ }),

/***/ 1717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _id_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/querystring/index.js
var querystring = __webpack_require__(17673);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@wartek-id/text/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(89004);
// EXTERNAL MODULE: ./node_modules/@wartek-id/button/dist/index.esm.js + 1 modules
var dist_index_esm = __webpack_require__(54204);
// EXTERNAL MODULE: ./node_modules/@wartek-id/shimmer/dist/index.esm.js + 1 modules
var shimmer_dist_index_esm = __webpack_require__(28058);
// EXTERNAL MODULE: ./node_modules/@wartek-id/header-bar/dist/index.esm.js + 1 modules
var header_bar_dist_index_esm = __webpack_require__(89140);
// EXTERNAL MODULE: ./node_modules/@wartek-id/icon/dist/index.esm.js + 1 modules
var icon_dist_index_esm = __webpack_require__(21958);
// EXTERNAL MODULE: ./node_modules/@wartek-id/fe-toolbox/dist/history.mjs
var dist_history = __webpack_require__(72955);
;// CONCATENATED MODULE: ./utils/hooks/useIsomorphicLayoutEffect.ts

var useIsomorphicLayoutEffect =  true ? react.useLayoutEffect : 0;

;// CONCATENATED MODULE: ./utils/hooks/useScrollPosition.ts


var isBrowser = "object" !== "undefined";
var zeroPosition = {
    x: 0,
    y: 0
};
var getClientRect = function(element) {
    return element === null || element === void 0 ? void 0 : element.getBoundingClientRect();
};
var getScrollPosition = function(param) {
    var element = param.element, useWindow = param.useWindow, boundingElement = param.boundingElement;
    if (!isBrowser) {
        return zeroPosition;
    }
    if (useWindow) {
        return {
            x: window.scrollX,
            y: window.scrollY
        };
    }
    var targetPosition = getClientRect((element === null || element === void 0 ? void 0 : element.current) || document.body);
    var containerPosition = getClientRect(boundingElement === null || boundingElement === void 0 ? void 0 : boundingElement.current);
    if (!targetPosition) {
        return zeroPosition;
    }
    return containerPosition ? {
        x: (containerPosition.x || 0) - (targetPosition.x || 0),
        y: (containerPosition.y || 0) - (targetPosition.y || 0)
    } : {
        x: targetPosition.left,
        y: targetPosition.top
    };
};
var useScrollPosition = function(param) {
    var effect = param.effect, deps = param.deps, element = param.element, useWindow = param.useWindow, wait = param.wait, boundingElement = param.boundingElement;
    var position = (0,react.useRef)(getScrollPosition({
        useWindow: useWindow,
        boundingElement: boundingElement
    }));
    var throttleTimeout = null;
    var callBack = function() {
        var currPos = getScrollPosition({
            element: element,
            useWindow: useWindow,
            boundingElement: boundingElement
        });
        effect({
            prevPos: position.current,
            currPos: currPos
        });
        position.current = currPos;
        throttleTimeout = null;
    };
    useIsomorphicLayoutEffect(function() {
        if (!isBrowser) {
            return undefined;
        }
        var handleScroll = function() {
            if (wait) {
                if (throttleTimeout === null) {
                    throttleTimeout = window.setTimeout(callBack, wait);
                }
            } else {
                callBack();
            }
        };
        if (boundingElement) {
            var ref;
            (ref = boundingElement.current) === null || ref === void 0 ? void 0 : ref.addEventListener("scroll", handleScroll, {
                passive: true
            });
        } else {
            window.addEventListener("scroll", handleScroll, {
                passive: true
            });
        }
        return function() {
            if (boundingElement) {
                var ref;
                (ref = boundingElement.current) === null || ref === void 0 ? void 0 : ref.removeEventListener("scroll", handleScroll);
            } else {
                window.removeEventListener("scroll", handleScroll);
            }
            if (throttleTimeout) {
                clearTimeout(throttleTimeout);
            }
        };
    }, deps);
};
useScrollPosition.defaultProps = {
    deps: [],
    element: false,
    useWindow: false,
    wait: null,
    boundingElement: false
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react-pdf/dist/esm/entry.js + 27 modules
var entry = __webpack_require__(83203);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./utils/hooks/useWindowDimensions.ts



function getWindowDimensions() {
    var width = window.innerWidth, height = window.innerHeight;
    return {
        width: width,
        height: height
    };
}
function getElementDimensionById(id) {
    var ref = document.getElementById(id), tmp = ref.offsetWidth, width = tmp === void 0 ? null : tmp, tmp1 = ref.offsetHeight, height = tmp1 === void 0 ? null : tmp1;
    return {
        width: width,
        height: height
    };
}
function useWindowDimensions() {
    var ref = (0,react.useState)(getWindowDimensions()), windowDimensions = ref[0], setWindowDimensions = ref[1];
    (0,react.useEffect)(function() {
        var handleResize = function handleResize() {
            setWindowDimensions(getWindowDimensions());
        };
        window.addEventListener("resize", handleResize);
        return function() {
            return window.removeEventListener("resize", handleResize);
        };
    }, []);
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, windowDimensions), {
        getElementDimensionById: getElementDimensionById
    });
}

;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/partials/AksiNyata/PdfReader.tsx








entry/* pdfjs.GlobalWorkerOptions.workerSrc */.v0.GlobalWorkerOptions.workerSrc = "//cdnjs.cloudflare.com/ajax/libs/pdf.js/".concat(entry/* pdfjs.version */.v0.version, "/pdf.worker.min.js");
var INITIAL_SCALE = 1.0;
var PADDING_SIZE = 32;
var PDFReader = function(param) {
    var url = param.url, _isSticky = param.isSticky, isSticky = _isSticky === void 0 ? false : _isSticky;
    var ref;
    var ref1 = (0,react.useState)(0), wrapperWidth = ref1[0], setWrapperWidth = ref1[1];
    var ref2 = useWindowDimensions(), width = ref2.width, getElementDimensionById = ref2.getElementDimensionById;
    var ref3 = (0,react.useState)(null), numPages = ref3[0], setNumPages = ref3[1];
    var ref4 = (0,react.useState)(INITIAL_SCALE), scale = ref4[0], setScale = ref4[1];
    var ref5 = (0,react.useState)(false), isLoaded = ref5[0], setIsLoaded = ref5[1];
    var file = (0,react.useMemo)(function() {
        return {
            url: url
        };
    }, [
        url
    ]);
    var rootRef = react.useRef(null);
    var onDocumentLoadSuccess = function(param) {
        var numPages = param.numPages;
        setIsLoaded(true);
        setNumPages(numPages);
    };
    (0,react.useEffect)(function() {
        var ref = getElementDimensionById("viewerWrapper"), elementWidth = ref.width;
        setWrapperWidth(elementWidth);
    }, [
        getElementDimensionById
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            ref: rootRef,
            className: "relative border border-gray-5 rounded-sm px-4 py-2 bg-gray-5",
            children: [
                isLoaded && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)("z-10", isSticky ? "fixed top-[72px]" : "absolute top-4"),
                    style: {
                        right: isSticky ? (window.innerWidth - ((ref = rootRef.current) === null || ref === void 0 ? void 0 : ref.offsetWidth)) / 2 : 0
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            "data-testid": "zoom_in",
                            onClick: function() {
                                return setScale(function(old) {
                                    return old + 0.3;
                                });
                            },
                            className: "flex items-center justify-center w-8 h-8 bg-white shadow-sm border border-gray-50 rounded-t",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.J, {
                                children: "zoom_in"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            "data-testid": "zoom_out",
                            onClick: function() {
                                return setScale(function(old) {
                                    return old - 0.3 >= 0.1 ? old - 0.3 : 0.1;
                                });
                            },
                            className: "flex items-center justify-center w-8 h-8 bg-white shadow-sm border border-gray-50 border-t-0 rounded-b",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.J, {
                                children: "zoom_out"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "viewerContainer",
                    className: "relative z-0 overflow-auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "viewerWrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(entry/* Document */.BB, {
                            file: file,
                            error: function() {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.x, {
                                    as: "div",
                                    className: "w-full h-full flex items-center",
                                    variant: "body",
                                    color: "critical",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.J, {
                                            color: "critical",
                                            children: "error_outline"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "ml-1",
                                            children: "Terjadi kesalahan saat memuat dokumen..."
                                        })
                                    ]
                                });
                            },
                            loading: function() {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.x, {
                                    as: "div",
                                    className: "w-full h-full flex items-center p-3 my-2 bg-surface-subdued border border-surface-neutral-subdued rounded",
                                    variant: "body",
                                    color: "informational",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.J, {
                                            className: "animate-spin",
                                            color: "informational",
                                            children: "loop"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "ml-1",
                                            children: "Sedang mengunduh dokumen..."
                                        })
                                    ]
                                });
                            },
                            externalLinkTarget: "_blank",
                            onLoadSuccess: onDocumentLoadSuccess,
                            children: (0,_to_consumable_array/* default */.Z)(Array(numPages)).map(function(_, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(entry/* Page */.T3, {
                                    pageNumber: index + 1,
                                    className: "pdf-viewer-page",
                                    renderAnnotationLayer: false,
                                    renderTextLayer: false,
                                    scale: scale,
                                    width: (wrapperWidth || width) - PADDING_SIZE
                                }, "pdf-viewer-page-".concat(index, "@").concat(scale));
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var PdfReader = (PDFReader);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@wartek-id/dialog/dist/index.esm.js + 1 modules
var dialog_dist_index_esm = __webpack_require__(25929);
// EXTERNAL MODULE: ./api/microlearning/useAPITopics.ts
var useAPITopics = __webpack_require__(14644);
// EXTERNAL MODULE: ./node_modules/@wartek-id/avatar/dist/index.esm.js + 1 modules
var avatar_dist_index_esm = __webpack_require__(42586);
// EXTERNAL MODULE: ./components/Anchor/index.tsx
var Anchor = __webpack_require__(55231);
// EXTERNAL MODULE: ./utils/hooks/context/useFeatureFlagContext.tsx + 1 modules
var useFeatureFlagContext = __webpack_require__(66578);
;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/components/AvatarProfile/index.tsx







var AvatarProfile = function(param) {
    var email = param.email, url = param.url, name = param.name, src = param.src;
    var getFeatureByKey = (0,useFeatureFlagContext/* useFeatureFlagContext */.dG)().getFeatureByKey;
    var isProfileLinkActive = getFeatureByKey("profileLink");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center mb-4 relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar_dist_index_esm/* Avatar */.q, {
                src: src,
                name: name,
                alt: name,
                size: "lg"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "ml-3 flex flex-col",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.x, {
                        variant: "body",
                        className: "break-all",
                        children: name || email
                    }),
                    isProfileLinkActive && url && /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* Anchor */.e, {
                        href: url,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.x, {
                            variant: "helper-bold",
                            className: "break-all hover:underline overlay-link flex items-center",
                            children: [
                                "Lihat profil",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.J, {
                                    fontSize: "small",
                                    as: "i",
                                    className: "font-bold",
                                    children: "chevron_right"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_AvatarProfile = (AvatarProfile);

;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/partials/AksiNyata/ViewHeading.tsx
/* provided dependency */ var process = __webpack_require__(34155);











var ReviewerInfos = [
    "Penelaah Aksi Nyata menelaah kesesuaian komponen Aksi Nyata dengan Panduan Aksi Nyata.",
    "Penelaah telah mengkuti Pelatihan Penelaahan Aksi Nyata Sejawat.",
    "Pembagian Aksi Nyata dalam penelaahan diacak oleh sistem.", 
];
var DialogValidator = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose, id = param.id;
    var reviewerUrl = "https://guru.kemdikbud.go.id" + "/profil/".concat(id);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog_dist_index_esm/* Dialog */.Vq, {
        isOpen: isOpen,
        onClose: onClose,
        size: "sm",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog_dist_index_esm/* DialogOverlay */.t9, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog_dist_index_esm/* DialogContent */.cZ, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "pt-8 pb-4 px-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-col items-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "https://storage.googleapis.com/microlearning-public-production/web-assets/img-aksi-nyata.png",
                                alt: "reviewer",
                                width: 128,
                                height: 128
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.x, {
                            variant: "heading-lg",
                            className: "text-center mt-4 mb-4",
                            children: "Penelaah Aksi Nyata"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "pl-6 list-disc px-2 mb-6",
                            children: ReviewerInfos.map(function(info, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.x, {
                                        color: "subdued",
                                        children: info
                                    })
                                }, index);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Button */.z, {
                            size: "lg",
                            className: "mb-2",
                            color: "black",
                            fullWidth: true,
                            onClick: onClose,
                            children: "Tutup"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* Anchor */.e, {
                            href: reviewerUrl,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Button */.z, {
                                size: "lg",
                                fullWidth: true,
                                color: "white",
                                children: "Ke Profil Penelaah"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var ViewHeading = function(param) {
    var title = param.title, author = param.author, selectedTitle = param.selectedTitle, topikId = param.topikId, topikName = param.topikName, _showCta = param.showCta, showCta = _showCta === void 0 ? true : _showCta, state = param.state, reviewer = param.reviewer;
    var isValidated = state === "VALIDATED";
    var relevanceTopics = (0,useAPITopics/* useGetRelevanceTopic */.TA)(topikId);
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isOpenReviewer = ref[0], setIsOpenReviewer = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "p-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: isValidated && "p-4 border border-green-50 rounded-t-md",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.x, {
                        className: "mb-1",
                        as: "h2",
                        variant: "heading-lg",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.x, {
                        className: "mb-4",
                        variant: "helper-bold",
                        color: "subdued",
                        children: [
                            topikName,
                            "\xa0–\xa0",
                            selectedTitle
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AvatarProfile, {
                        email: author.email,
                        url: author.id && "https://guru.kemdikbud.go.id" + "/profil/".concat(author.id),
                        src: author.avatarUrl,
                        name: author.name
                    }),
                    showCta && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bg-surface-subdued border border-surface-neutral-subdued p-3 rounded",
                        children: [
                            relevanceTopics.isSuccess && relevanceTopics.data.data.topics.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.x, {
                                variant: "body-sm",
                                className: "mb-3",
                                children: [
                                    "Ingin bisa menerapkan pembelajaran seperti ini? Pelajari topik\xa0",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: relevanceTopics.data.data.topics[0].name
                                    }),
                                    " ",
                                    "untuk dapat materi lengkapnya."
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.x, {
                                variant: "body-sm",
                                className: "mb-3",
                                children: "Ingin bisa menerapkan pembelajaran seperti ini? Pelajari materi lengkapnya di Pelatihan Mandiri."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* Anchor */.e, {
                                    href: "/".concat(process.env.NEXT_PUBLIC_TEMP_PELATIHAN_MANDIRI_PATH || "pelatihan-mandiri").concat(relevanceTopics.isSuccess && relevanceTopics.data.data.topics.length > 0 ? "/topik/" + relevanceTopics.data.data.topics[0].id : ""),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.x, {
                                        className: "inline-block py-[6px] px-[10px] border border-default rounded",
                                        variant: "body-sm",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: relevanceTopics.isSuccess && relevanceTopics.data.data.topics.length > 0 ? "Buka ".concat(relevanceTopics.data.data.topics[0].name) : "Lihat Topik Pelatihan"
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            isValidated && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center bg-green-50 p-2 rounded-b-md text-white cursor-pointer justify-between",
                        onClick: function() {
                            return setIsOpenReviewer(!!reviewer.reviewerName);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.J, {
                                        fontSize: "small",
                                        className: "mr-2 text-white",
                                        color: "inverse",
                                        children: "check_circle"
                                    }),
                                    !reviewer.reviewerName ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-sm font-semibold",
                                        children: "Sudah ditelaah"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "text-sm font-semibold",
                                        children: [
                                            "Ditelaah oleh ",
                                            reviewer.reviewerName
                                        ]
                                    })
                                ]
                            }),
                            reviewer.reviewerName && /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.J, {
                                fontSize: "small",
                                color: "inverse",
                                children: "chevron_right"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogValidator, {
                        isOpen: isOpenReviewer,
                        onClose: function() {
                            return setIsOpenReviewer(false);
                        },
                        id: reviewer.reviewerUserID
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var AksiNyata_ViewHeading = (ViewHeading);

// EXTERNAL MODULE: ./utils/text.ts + 1 modules
var utils_text = __webpack_require__(40999);
;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/partials/AksiNyata/ViewMeta.tsx









var ViewMeta = function(param) {
    var description = param.description, reflection = param.reflection;
    var descRef = react.useRef(null);
    var reflectionRef = react.useRef(null);
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState({
        desc: false,
        refleksi: false
    }), 2), showMore = ref[0], setShowMore = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState({
        desc: false,
        refleksi: false
    }), 2), isExpanded = ref1[0], setExpanded = ref1[1];
    var toggleExpanded = function(newValue) {
        setExpanded(function(old) {
            return (0,_object_spread/* default */.Z)({}, old, newValue);
        });
    };
    react.useLayoutEffect(function() {
        var ref, ref1, ref2, ref3;
        if (((ref = descRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight) < ((ref1 = descRef.current) === null || ref1 === void 0 ? void 0 : ref1.scrollHeight)) {
            setShowMore(function(old) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, old), {
                    desc: true
                });
            });
        }
        if (((ref2 = reflectionRef.current) === null || ref2 === void 0 ? void 0 : ref2.clientHeight) < ((ref3 = reflectionRef.current) === null || ref3 === void 0 ? void 0 : ref3.scrollHeight)) {
            setShowMore(function(old) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, old), {
                    refleksi: true
                });
            });
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "p-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.x, {
                        className: "mb-2",
                        variant: "heading-sm",
                        children: "Deskripsi"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.x, {
                        as: "div",
                        ref: descRef,
                        className: (0,clsx_m/* default */.Z)("break-words", !isExpanded.desc && "line-clamp-3"),
                        dangerouslySetInnerHTML: {
                            __html: (0,utils_text/* nl2br */.hU)(description)
                        }
                    }),
                    showMore.desc && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: "flex items-center",
                        onClick: function() {
                            return toggleExpanded({
                                desc: !isExpanded.desc
                            });
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.x, {
                                variant: "body-sm",
                                className: "underline",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: isExpanded.desc ? "Ringkas" : "Selengkapnya"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.J, {
                                as: "i",
                                color: "default",
                                fontSize: "default",
                                className: (0,clsx_m/* default */.Z)(isExpanded.desc ? "transform rotate-180 origin-center" : ""),
                                children: "keyboard_arrow_down_icon"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.x, {
                        className: "mb-2",
                        variant: "heading-sm",
                        children: "Refleksi"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.x, {
                        as: "div",
                        ref: reflectionRef,
                        className: (0,clsx_m/* default */.Z)("break-words", !isExpanded.refleksi && "line-clamp-3"),
                        dangerouslySetInnerHTML: {
                            __html: (0,utils_text/* nl2br */.hU)(reflection)
                        }
                    }),
                    showMore.refleksi && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: "flex items-center",
                        onClick: function() {
                            return toggleExpanded({
                                refleksi: !isExpanded.refleksi
                            });
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.x, {
                                variant: "body-sm",
                                className: "underline",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: isExpanded.refleksi ? "Ringkas" : "Selengkapnya"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.J, {
                                className: (0,clsx_m/* default */.Z)(isExpanded.refleksi ? "transform rotate-180 origin-center" : ""),
                                as: "i",
                                color: "default",
                                fontSize: "default",
                                children: "keyboard_arrow_down_icon"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var AksiNyata_ViewMeta = (ViewMeta);

// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var react_hook_form_dist_index_esm = __webpack_require__(4317);
// EXTERNAL MODULE: ./node_modules/@wartek-id/textarea/dist/index.esm.js + 1 modules
var textarea_dist_index_esm = __webpack_require__(32036);
// EXTERNAL MODULE: ./node_modules/@wartek-id/toast/dist/index.esm.js + 1 modules
var toast_dist_index_esm = __webpack_require__(55086);
// EXTERNAL MODULE: ./utils/datetime.ts + 1 modules
var datetime = __webpack_require__(1413);
;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/partials/AksiNyata/FeedbackCard.tsx









var FeedbackCard = function(param) {
    var authorEmail = param.authorEmail, avatarUrl = param.avatarUrl, authorName = param.authorName, createdAt = param.createdAt, content = param.content;
    var feedbackRef = react.useRef(null);
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), showMore = ref[0], setShowMore = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), expanded = ref1[0], setExpanded = ref1[1];
    react.useLayoutEffect(function() {
        var ref, ref1;
        if (((ref = feedbackRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight) < ((ref1 = feedbackRef.current) === null || ref1 === void 0 ? void 0 : ref1.scrollHeight)) {
            setShowMore(true);
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex mb-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar_dist_index_esm/* Avatar */.q, {
                className: "flex-shrink-0 flex-grow-0",
                src: avatarUrl,
                name: authorName,
                alt: authorName
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "ml-4 overflow-auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.x, {
                        className: "mb-2",
                        as: "div",
                        color: "subdued",
                        variant: "helper",
                        children: [
                            !!authorName && authorName.length > 0 ? authorName : authorEmail,
                            "\xa0\xb7\xa0",
                            (0,datetime/* timeAgo */.Sy)(createdAt)
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.x, {
                                ref: feedbackRef,
                                className: (0,clsx_m/* default */.Z)("break-words", !expanded && "line-clamp-5"),
                                dangerouslySetInnerHTML: {
                                    __html: (0,utils_text/* nl2br */.hU)((0,utils_text/* stripHTMLTags */.ox)(content))
                                }
                            }),
                            showMore && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                className: "flex items-center",
                                onClick: function() {
                                    return setExpanded(function(old) {
                                        return !old;
                                    });
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.x, {
                                        variant: "body-sm",
                                        className: "underline",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: expanded ? "Ringkas" : "Selengkapnya"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.J, {
                                        as: "i",
                                        color: "default",
                                        fontSize: "default",
                                        className: (0,clsx_m/* default */.Z)(expanded ? "transform rotate-180 origin-center" : ""),
                                        children: "keyboard_arrow_down_icon"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var AksiNyata_FeedbackCard = (FeedbackCard);

// EXTERNAL MODULE: ./api/microlearning/useAPIAksiNyata.ts
var useAPIAksiNyata = __webpack_require__(83759);
;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/partials/AksiNyata/AksiNyataFeedbackList.tsx















var AksiNyataFeedbackList = function(param) {
    var aksiNyataId = param.aksiNyataId, feedbackFetchStatus = param.feedbackFetchStatus, feedbacks = param.feedbacks, hasFeedback = param.hasFeedback, topikId = param.topikId, _topikName = param.topikName, topikName = _topikName === void 0 ? "" : _topikName, _onShareButtonClick = param.onShareButtonClick, onShareButtonClick = _onShareButtonClick === void 0 ? function() {} : _onShareButtonClick, _isOwner = param.isOwner, isOwner = _isOwner === void 0 ? false : _isOwner, onRefreshFeedback = param.onRefreshFeedback;
    var ref;
    var toast = (0,toast_dist_index_esm/* useToast */.pm)();
    var query = (0,router.useRouter)().query;
    var ref1 = (0,react_hook_form_dist_index_esm/* useForm */.cI)({
        mode: "onChange"
    }), register = ref1.register, trigger = ref1.trigger, getValues = ref1.getValues, errors = ref1.formState.errors;
    var tanggapanPlaceholderText = "Contoh: Secara keseluruhan kontennya sangat bagus dan sesuai dengan tuntutan standar kompetensi murid. Namun, sebaiknya diberikan contoh agar materi dapat lebih mudah dipahami.";
    var ref2 = (0,useAPIAksiNyata/* usePostAksiNyataFeedback */.yc)(query.id, {
        onSuccess: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        toast({
                            message: "Berhasil kirim tanggapan!",
                            type: "success"
                        });
                        return [
                            4,
                            onRefreshFeedback()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        }),
        onError: function() {
            toast({
                message: "Mohon maaf, tanggapan gagal dikirim. Silahkan coba lagi"
            });
        }
    }), mutateAsync = ref2.mutateAsync, isLoading = ref2.isLoading;
    var submitForm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var isValidated, value, likerts;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            trigger([
                                "tanggapan"
                            ])
                        ];
                    case 1:
                        isValidated = _state.sent();
                        if (!isValidated) return [
                            3,
                            3
                        ];
                        value = getValues();
                        likerts = {
                            likert_1: "1",
                            likert_2: "1",
                            likert_3: "1",
                            likert_4: "1",
                            likert_5: "1"
                        };
                        return [
                            4,
                            mutateAsync({
                                submission: (0,_object_spread/* default */.Z)({}, likerts, value)
                            })
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function submitForm() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)("px-4 mb-4 pt-4 border-t border-subdued", hasFeedback && "pb-5 border-b"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.x, {
                        className: "mb-4",
                        variant: "heading-sm",
                        children: "Komentar"
                    }),
                    isOwner && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.x, {
                                children: "Ingin tahu hal yang perlu Anda pertahankan/tingkatkan dari Aksi Nyata ini? Bagikan ke rekan guru untuk mendapat tanggapan."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Button */.z, {
                                    onClick: onShareButtonClick,
                                    size: "lg",
                                    fullWidth: true,
                                    children: "Bagikan Aksi Nyata"
                                })
                            })
                        ]
                    }),
                    !isOwner && !hasFeedback && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-4 bg-white rounded-lg",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(textarea_dist_index_esm/* Textarea */.g, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                    placeholder: tanggapanPlaceholderText,
                                    isDisabled: isLoading,
                                    id: "tanggapan"
                                }, register("tanggapan", {
                                    validate: {
                                        required: function(v) {
                                            return v.trim().length > 0 || "Tanggapan tidak boleh kosong";
                                        }
                                    }
                                })), {
                                    isInvalid: Boolean(errors.tanggapan),
                                    errorMessage: (ref = errors.tanggapan) === null || ref === void 0 ? void 0 : ref.message
                                }))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Button */.z, {
                                    onClick: submitForm,
                                    isLoading: isLoading,
                                    disabled: isLoading,
                                    color: "blue",
                                    fullWidth: true,
                                    size: "lg",
                                    children: "Kirim Komentar"
                                })
                            })
                        ]
                    }),
                    !isOwner && hasFeedback && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "p-3 border border-default rounded",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.x, {
                                children: "Terima kasih atas tanggapan Anda! Jika berkenan, bantu bagikan juga ke rekan guru lainnya untuk mendapat lebih banyak masukan."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Button */.z, {
                                    color: "white",
                                    onClick: onShareButtonClick,
                                    size: "lg",
                                    fullWidth: true,
                                    children: "Bagikan Aksi Nyata"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "px-4",
                children: feedbackFetchStatus === "success" && (feedbacks === null || feedbacks === void 0 ? void 0 : feedbacks.length) > 0 && (feedbacks === null || feedbacks === void 0 ? void 0 : feedbacks.map(function(feedback, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AksiNyata_FeedbackCard, {
                        aksiNyataId: aksiNyataId,
                        topikId: topikId,
                        topikName: topikName,
                        authorId: feedback.author.id,
                        authorName: feedback.author.name,
                        authorEmail: feedback.author.email,
                        createdAt: feedback.createdAt,
                        avatarUrl: undefined,
                        content: feedback.submission.tanggapan
                    }, index);
                }))
            })
        ]
    });
};
/* harmony default export */ var AksiNyata_AksiNyataFeedbackList = (AksiNyataFeedbackList);

;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/partials/AksiNyata/Placeholder.tsx



var ViewAksiNyataPlaceholder = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pb-5 px-4 mb-4 border-b border-subdued",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex mb-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(shimmer_dist_index_esm/* Shimmer */.q, {
                                height: 106,
                                width: 106
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "ml-6 flex-auto",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(shimmer_dist_index_esm/* Shimmer */.q, {
                                        className: "mb-2",
                                        height: 16,
                                        noOfLines: 2,
                                        style: {
                                            width: "100%"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(shimmer_dist_index_esm/* Shimmer */.q, {
                                        height: 10,
                                        noOfLines: 1,
                                        style: {
                                            width: "100%"
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(shimmer_dist_index_esm/* Shimmer */.q, {
                        height: 46,
                        style: {
                            width: "100%"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "px-4 mb-4 pb-5 px-4 border-b border-subdued",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(shimmer_dist_index_esm/* Shimmer */.q, {
                                className: "mb-2",
                                height: 16,
                                width: 120
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(shimmer_dist_index_esm/* Shimmer */.q, {
                                        height: 48,
                                        width: 48,
                                        rounded: true
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "ml-3 flex-auto",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shimmer_dist_index_esm/* Shimmer */.q, {
                                            height: 16,
                                            style: {
                                                width: "100%"
                                            }
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "px-4 mb-4 pb-5 border-b border-subdued",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mb-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(shimmer_dist_index_esm/* Shimmer */.q, {
                                        className: "mb-4",
                                        height: 16,
                                        style: {
                                            width: "100%"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(shimmer_dist_index_esm/* Shimmer */.q, {
                                        className: "mb-2",
                                        height: 16,
                                        noOfLines: 4,
                                        style: {
                                            width: "100%"
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mb-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(shimmer_dist_index_esm/* Shimmer */.q, {
                                        className: "mb-4",
                                        height: 16,
                                        style: {
                                            width: "100%"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(shimmer_dist_index_esm/* Shimmer */.q, {
                                        className: "mb-2",
                                        height: 16,
                                        noOfLines: 4,
                                        style: {
                                            width: "100%"
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Placeholder = (ViewAksiNyataPlaceholder);

;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/partials/AksiNyata/index.ts






// EXTERNAL MODULE: ./utils/androidHandler.ts
var utils_androidHandler = __webpack_require__(84494);
// EXTERNAL MODULE: ./configs/androiVersionMap.ts
var androiVersionMap = __webpack_require__(91003);
// EXTERNAL MODULE: ./utils/auth/index.tsx + 4 modules
var auth = __webpack_require__(23475);
// EXTERNAL MODULE: ./components/EmptyState/index.ts + 1 modules
var EmptyState = __webpack_require__(99270);
// EXTERNAL MODULE: ./components/SocialShareDrawer/index.ts + 4 modules
var SocialShareDrawer = __webpack_require__(70586);
// EXTERNAL MODULE: ./components/Layout/Desktop/DesktopLayout.tsx
var DesktopLayout = __webpack_require__(72351);
;// CONCATENATED MODULE: ./pages/pelatihan-mandiri/aksi-nyata/[id]/index.tsx
/* provided dependency */ var _id_process = __webpack_require__(34155);

























var AksiNyataPage = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38;
    var ref39 = (0,router.useRouter)(), query = ref39.query, replace = ref39.replace, back = ref39.back, push = ref39.push;
    var isDesktopScreenSize = props.isDesktopScreenSize;
    var currentAksiNyata = (0,useAPIAksiNyata/* useGetPublicAksiNyata */.Ru)(query.id);
    var currentFeedback = (0,useAPIAksiNyata/* useGetAksiNyataFeedback */.V0)(query.id, currentAksiNyata.isSuccess);
    var ref40 = (0,react.useState)(false), showShareDialog = ref40[0], setShowShareDialog = ref40[1];
    var ref41 = (0,react.useState)(false), hasFeedback = ref41[0], setHasFeedback = ref41[1];
    var shareText = (0,react.useRef)("");
    var session = (0,auth/* useAuth */.aC)().session;
    var androidHandler = (0,utils_androidHandler/* default */.ZP)();
    var readerRef = react.useRef(null);
    var ref42 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isSticky = ref42[0], setSticky = ref42[1];
    useScrollPosition({
        effect: function(param) {
            var currPos = param.currPos;
            var ref;
            if (((ref = readerRef.current) === null || ref === void 0 ? void 0 : ref.offsetTop) + currPos.y - 64 <= 0) {
                setSticky(true);
            } else {
                if (isSticky === true) {
                    setSticky(false);
                }
            }
        }
    });
    (0,react.useEffect)(function() {
        if (currentFeedback.isSuccess) {
            var currentUserFeedback = currentFeedback.data.data.find(function(feedback) {
                var ref, ref1;
                return (feedback === null || feedback === void 0 ? void 0 : (ref = feedback.author) === null || ref === void 0 ? void 0 : ref.id) === (session === null || session === void 0 ? void 0 : (ref1 = session.user) === null || ref1 === void 0 ? void 0 : ref1.id);
            });
            setHasFeedback(typeof currentUserFeedback !== "undefined");
        }
    }, [
        session === null || session === void 0 ? void 0 : (ref = session.user) === null || ref === void 0 ? void 0 : ref.id,
        currentFeedback.isSuccess,
        currentFeedback.data
    ]);
    (0,react.useEffect)(function() {
        if (currentAksiNyata.isSuccess) {
            var ref, ref1, ref2, ref3;
            if (((ref = currentAksiNyata.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.creator) === null || ref2 === void 0 ? void 0 : ref2.email) === (session === null || session === void 0 ? void 0 : (ref3 = session.user) === null || ref3 === void 0 ? void 0 : ref3.email)) {
                shareText.current = "Bapak/Ibu Guru, saya melakukan *Aksi Nyata* sebagai implementasi " + "pemahaman saya terhadap salah satu topik Pelatihan Mandiri di " + "platform Merdeka Mengajar \n\n" + "Mohon bantuan Bapak/Ibu Guru untuk memberikan " + "tanggapan di tautan berikut. Terima kasih.";
            } else {
                var ref4, ref5;
                shareText.current = "Bapak/Ibu Guru, berikut ada Aksi Nyata rekan sejawat " + "mengenai ".concat((ref4 = currentAksiNyata.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.data) === null || ref5 === void 0 ? void 0 : ref5.title, " \n\n") + "Beliau membutuhkan tanggapan untuk Aksi Nyata ini, " + "mari kita bantu tanggapi di tautan berikut." + " Terima kasih.";
            }
        }
    }, [
        session,
        currentAksiNyata.data,
        currentAksiNyata.isSuccess
    ]);
    var shareUrl = "".concat("https://guru.kemdikbud.go.id", "/").concat(_id_process.env.NEXT_PUBLIC_TEMP_PELATIHAN_MANDIRI_PATH || "pelatihan-mandiri", "/aksi-nyata/").concat(query.id, "?") + (0,querystring.stringify)({
        topik_name: query.topik_name,
        topik_id: query.topik_id
    });
    var triggerShareDialog = function() {
        if (androidHandler.enabled) {
            androidHandler.shareToolkitUrl("".concat(shareText.current, "  ").concat(shareUrl));
        } else {
            setShowShareDialog(true);
        }
    };
    var triggerRefecthComment = function() {
        currentFeedback.refetch();
    };
    var shouldShowFeedbackField = [
        "COMPLETED",
        "VALIDATED"
    ].includes((ref1 = currentAksiNyata.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.state);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopLayout/* WithLayoutListener */.nc, {
        isDesktop: isDesktopScreenSize,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                        children: [
                            "Guru Mengajar | Aksi nyata ",
                            (ref3 = currentAksiNyata.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : ref4.title
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(header_bar_dist_index_esm/* HeaderBar */.h_, {
                    fixed: true,
                    className: "z-10",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(header_bar_dist_index_esm/* HeaderBarLeftAction */.l8, {
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.J, {
                                children: "arrow_back"
                            }),
                            onClick: function() {
                                if (androidHandler.enabled && androidHandler.getVersion() >= androiVersionMap/* ANDROID_VERSION_MAP.PELATIHAN_MANDIRI_NATIVE */.q.PELATIHAN_MANDIRI_NATIVE) {
                                    androidHandler.backToApp();
                                } else {
                                    dist_history/* backToApp */.NU(back);
                                }
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(header_bar_dist_index_esm/* HeaderBarTitle */.rF, {
                            children: "Aksi Nyata"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(header_bar_dist_index_esm/* HeaderBarRightAction */.so, {
                            onClick: triggerShareDialog,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.J, {
                                children: "share"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)("relative py-5 z-0", isDesktopScreenSize && "bg-white rounded-md"),
                    style: {
                        minHeight: "calc(100vh - 3.5rem)"
                    },
                    children: [
                        currentAksiNyata.isSuccess ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AksiNyata_ViewHeading, {
                                    title: (ref5 = currentAksiNyata.data.data) === null || ref5 === void 0 ? void 0 : ref5.title,
                                    author: (ref6 = currentAksiNyata.data.data) === null || ref6 === void 0 ? void 0 : ref6.creator,
                                    topikId: query.topik_id,
                                    topikName: query.topik_name,
                                    state: (ref7 = currentAksiNyata.data.data) === null || ref7 === void 0 ? void 0 : ref7.state,
                                    reviewer: {
                                        reviewerName: ((ref8 = currentAksiNyata.data.data) === null || ref8 === void 0 ? void 0 : ref8.reviewerName) || "",
                                        reviewerUserID: ((ref9 = currentAksiNyata.data.data) === null || ref9 === void 0 ? void 0 : ref9.reviewerUserID) || ""
                                    },
                                    selectedTitle: (ref10 = currentAksiNyata.data.data) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.selectedOption) === null || ref11 === void 0 ? void 0 : ref11.title,
                                    showCta: (session === null || session === void 0 ? void 0 : (ref12 = session.user) === null || ref12 === void 0 ? void 0 : ref12.id) !== ((ref13 = currentAksiNyata.data) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.data) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.creator) === null || ref15 === void 0 ? void 0 : ref15.id) && (session === null || session === void 0 ? void 0 : (ref16 = session.user) === null || ref16 === void 0 ? void 0 : ref16.email) !== ((ref17 = currentAksiNyata.data) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.data) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.creator) === null || ref19 === void 0 ? void 0 : ref19.email)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AksiNyata_ViewMeta, {
                                    description: (ref20 = currentAksiNyata.data.data) === null || ref20 === void 0 ? void 0 : ref20.description,
                                    reflection: (ref21 = currentAksiNyata.data.data) === null || ref21 === void 0 ? void 0 : ref21.reflection
                                }),
                                ((ref22 = currentAksiNyata.data.data) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.attachments) === null || ref23 === void 0 ? void 0 : ref23[0].type) === "video" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "p-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Button */.z, {
                                        as: "a",
                                        target: "_blank",
                                        href: (ref24 = currentAksiNyata.data.data) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.attachments) === null || ref25 === void 0 ? void 0 : ref25[0].url,
                                        size: "lg",
                                        color: "black",
                                        fullWidth: true,
                                        children: "Lihat Video"
                                    })
                                }),
                                ((ref26 = currentAksiNyata.data.data) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.attachments) === null || ref27 === void 0 ? void 0 : ref27[0].type) === "pdf" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "p-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.x, {
                                            className: "mb-2",
                                            variant: "heading-sm",
                                            children: "Dokumen"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            ref: readerRef,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PdfReader, {
                                                isSticky: isSticky,
                                                url: (ref28 = currentAksiNyata.data.data) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.attachments) === null || ref29 === void 0 ? void 0 : ref29[0].url
                                            })
                                        })
                                    ]
                                })
                            ]
                        }) : currentAksiNyata.isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Placeholder, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyState/* EmptyState */.ub, {
                            title: "Tidak Dapat Ditampilkan",
                            description: "Anda tidak memiliki akses untuk melihat Aksi Nyata milik guru lain",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyState/* EmptyStateAction */.Px, {
                                onClick: function() {
                                    return replace("/".concat(_id_process.env.NEXT_PUBLIC_TEMP_PELATIHAN_MANDIRI_PATH || "pelatihan-mandiri"));
                                },
                                children: "Kembali ke daftar Topik"
                            })
                        }),
                        currentFeedback.isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(shimmer_dist_index_esm/* Shimmer */.q, {
                            className: "mb-2",
                            height: 16,
                            noOfLines: 4,
                            style: {
                                width: "100%"
                            }
                        }),
                        currentFeedback.isSuccess && shouldShowFeedbackField && /*#__PURE__*/ (0,jsx_runtime.jsx)(AksiNyata_AksiNyataFeedbackList, {
                            aksiNyataId: query.id,
                            topikId: query.topik_id,
                            topikName: query.topik_name,
                            hasFeedback: hasFeedback,
                            isOwner: (session === null || session === void 0 ? void 0 : (ref30 = session.user) === null || ref30 === void 0 ? void 0 : ref30.id) === ((ref31 = currentAksiNyata.data) === null || ref31 === void 0 ? void 0 : (ref32 = ref31.data) === null || ref32 === void 0 ? void 0 : (ref33 = ref32.creator) === null || ref33 === void 0 ? void 0 : ref33.id) || (session === null || session === void 0 ? void 0 : (ref34 = session.user) === null || ref34 === void 0 ? void 0 : ref34.email) === ((ref35 = currentAksiNyata.data) === null || ref35 === void 0 ? void 0 : (ref36 = ref35.data) === null || ref36 === void 0 ? void 0 : (ref37 = ref36.creator) === null || ref37 === void 0 ? void 0 : ref37.email),
                            feedbacks: (ref38 = currentFeedback.data) === null || ref38 === void 0 ? void 0 : ref38.data,
                            feedbackFetchStatus: currentFeedback.status,
                            onShareButtonClick: triggerShareDialog,
                            onGotoFormClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                var ref, ref1;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                push("/".concat(_id_process.env.NEXT_PUBLIC_TEMP_PELATIHAN_MANDIRI_PATH || "pelatihan-mandiri", "/aksi-nyata/").concat(query.id, "/form?") + "title=".concat((ref = currentAksiNyata.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.title))
                                            ];
                                        case 1:
                                            _state.sent();
                                            return [
                                                2
                                            ];
                                    }
                                });
                            }),
                            onRefreshFeedback: triggerRefecthComment
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialShareDrawer/* SocialShareDrawer */.P, {
                    isOpen: showShareDialog,
                    title: "Bagikan Aksi Nyata",
                    onClose: function() {
                        setShowShareDialog(false);
                    },
                    linkOnlyOnCopy: true,
                    shareText: shareText.current,
                    shareUrl: shareUrl
                })
            ]
        })
    });
};
AksiNyataPage.layoutOpts = {
    hasHeader: true,
    enableDesktopLayout: true
};
/* harmony default export */ var _id_ = (AksiNyataPage);


/***/ }),

/***/ 1413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Sz": function() { return /* binding */ getTimestampForGTag; },
  "ps": function() { return /* binding */ minuteToHour; },
  "Sy": function() { return /* binding */ timeAgo; }
});

// UNUSED EXPORTS: formatDate, humanizeDate, isoStringToDateInputTypeFormat, locale, months, youtubeDurationToHms, youtubeDurationToSeconds

// EXTERNAL MODULE: ./node_modules/timeago.js/esm/index.js + 6 modules
var esm = __webpack_require__(52165);
;// CONCATENATED MODULE: ./utils/number.ts
function roundWithPrecision(value, precision) {
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
}
var random = function(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
};
/**
 * Transforms a number into human-readable format with delimiters every three digits
 * @param {number} number     Number to be transformed
 * @param {string} delimiter  Delimiter character, choose between dots or commas
 *
 * @returns {string} Human-readable number representation with delimiters
 */ function delimit(number) {
    var delimiter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ".";
    var rgx = /\B(?=(\d{3})+(?!\d))/g;
    var result = "";
    var integerPart = Math.trunc(number);
    var decimalPart = parseFloat((number % 1).toFixed(2));
    var decimalDelimiter = delimiter === "." ? "," : ".";
    result = result + integerPart.toString().replace(rgx, delimiter);
    if (decimalPart) result = result + decimalDelimiter + decimalPart.toString().split(".")[1];
    return result;
}
/**
 * Helper function to render a number in a human-readable format
 * @param {number} num Number to be rendered
 * @param {number} decimals Trailing decimal places to be rendered
 * @param {number} step Multiplier between notations
 * @param {string[]} notations List of notations for the rendered string
 * @returns {string} Human-readable number with notation
 */ function humanizeNumber(num) {
    var decimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, step = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1000, notations = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [], separator = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
    if (num === 0) return "0" + (notations.length > 0 ? " ".concat(notations[0]) : "");
    var dm = decimals < 0 ? 0 : decimals;
    var i = Math.floor(Math.log(Math.abs(num)) / Math.log(step));
    return (delimit(parseFloat((num / Math.pow(step, i)).toFixed(dm))) + separator + notations[i]).trim();
}
/**
 * Formats bytes into most-appropriate decimal notation.
 *
 * @param {number} bytes    Number of bytes
 * @param {number} decimals Number of decimal places
 * @returns {string} Human-readable file size string
 *
 * @example
 * formatBytes(1248) // "1,2 KB"
 * formatBytes(1248, 2) // "1,25 KB"
 * formatBytes(1248, 2, '.') // 1.25 KB
 */ function formatBytes(bytes) {
    var decimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    var sizes = [
        "Byte",
        "KB",
        "MB",
        "GB",
        "TB",
        "PB",
        "EB",
        "ZB",
        "YB"
    ];
    return humanizeNumber(Math.abs(bytes), decimals, 1024, sizes, " ");
}

;// CONCATENATED MODULE: ./utils/datetime.ts




var locale = "id";
(0,esm/* register */.z2)(locale, function(_number, index, totalSec) {
    var translations = [
        [
            "baru saja",
            "sebentar"
        ],
        [
            "%s detik lalu",
            "dalam %s detik"
        ],
        [
            "1 menit lalu",
            "dalam 1 menit"
        ],
        [
            "%s menit lalu",
            "dalam %s menit"
        ],
        [
            "1 jam lalu",
            "dalam 1 jam"
        ],
        [
            "%s jam lalu",
            "dalam %s jam"
        ],
        [
            "1 hari lalu",
            "dalam 1 hari"
        ],
        [
            "%s hari lalu",
            "dalam %s hari"
        ],
        [
            "1 minggu lalu",
            "dalam 1 minggu"
        ],
        [
            "%s minggu lalu",
            "dalam %s minggu"
        ],
        [
            "1 bulan lalu",
            "dalam 1 bulan"
        ],
        [
            "%s bulan lalu",
            "dalam %s bulan"
        ],
        [
            "1 tahun lalu",
            "dalam 1 tahun"
        ],
        [
            "%s tahun lalu",
            "dalam %s tahun"
        ], 
    ];
    var translation = translations[index];
    if (translation[0].includes("minggu")) {
        var dayInSec = 86400;
        var days = Math.ceil(totalSec / dayInSec);
        return [
            "".concat(days, " hari lalu"),
            "dalam ".concat(days, " hari")
        ];
    }
    return translation;
});
var months = (/* unused pure expression or super */ null && ([
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember", 
]));
function humanizeDate(timestamp) {
    var dateObj = new Date(timestamp);
    var date = dateObj.getDate();
    var month = dateObj.getMonth();
    var year = dateObj.getFullYear();
    var hour = dateObj.getHours() > 9 ? dateObj.getHours() : "0" + dateObj.getHours();
    var minute = dateObj.getMinutes() > 9 ? dateObj.getMinutes() : "0" + dateObj.getMinutes();
    return "".concat(date, " ").concat(months[month], " ").concat(year, ", ").concat(hour, ":").concat(minute);
}
function youtubeDurationToSeconds(duration) {
    // https://developers.google.com/youtube/v3/docs/videos#contentDetails.duration
    var hours = 0;
    var minutes = 0;
    var seconds = 0;
    duration = duration.replace("PT", "");
    if (duration.indexOf("H") > -1) {
        var hoursSplit = duration.split("H");
        hours = parseInt(hoursSplit[0]);
        duration = hoursSplit[1];
    }
    if (duration.indexOf("M") > -1) {
        var minutesSplit = duration.split("M");
        minutes = parseInt(minutesSplit[0]);
        duration = minutesSplit[1];
    }
    if (duration.indexOf("S") > -1) {
        var secondsSplit = duration.split("S");
        seconds = parseInt(secondsSplit[0]);
    }
    return hours * 3600 + minutes * 60 + seconds;
}
function youtubeDurationToHms(duration) {
    var durationInSeconds = youtubeDurationToSeconds(duration);
    var hours = Math.floor(durationInSeconds / 3600);
    var minutes = Math.floor(durationInSeconds % 3600 / 60);
    var seconds = Math.floor(durationInSeconds % 3600 % 60);
    var hoursDisplay = hours > 0 ? String(hours).padStart(2, "0") + ":" : "";
    var minutesDisplay = String(minutes).padStart(2, "0") + ":";
    var secondsDisplay = String(seconds).padStart(2, "0");
    return hoursDisplay + minutesDisplay + secondsDisplay;
}
function timeAgo(datetime) {
    return (0,esm/* format */.WU)(datetime, locale);
}
function minuteToHour(minutes) {
    if (minutes < 60) {
        return "".concat(minutes, " menit");
    }
    return "".concat(roundWithPrecision(minutes / 60, 1), " jam");
}
function isoStringToDateInputTypeFormat(isoDateString) {
    var date = new Date(isoDateString);
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var dt = date.getDate();
    var sday = dt.toString();
    var smonth = month.toString();
    if (dt < 10) {
        sday = "0" + dt.toString();
    }
    if (month < 10) {
        smonth = "0" + month.toString();
    }
    return year.toString() + "-" + smonth + "-" + sday;
}
function getTimestampForGTag() {
    var date = new Date();
    date = new Date(date.getTime() - 3000000);
    return date.getFullYear().toString() + "-" + ((date.getMonth() + 1).toString().length == 2 ? (date.getMonth() + 1).toString() : "0" + (date.getMonth() + 1).toString()) + "-" + (date.getDate().toString().length == 2 ? date.getDate().toString() : "0" + date.getDate().toString()) + " " + (date.getHours().toString().length == 2 ? date.getHours().toString() : "0" + date.getHours().toString()) + ":" + ((date.getMinutes() / 5 * 5).toString().length == 2 ? (date.getMinutes() / 5 * 5).toString() : "0" + (date.getMinutes() / 5 * 5).toString()) + ":00";
}
function formatDate(datetime) {
    var formatString = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "dd MMMM yyyy";
    return formatFns(new Date(datetime), formatString, {
        locale: id
    });
}


/***/ }),

/***/ 14601:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 32767:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 28251:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 57677:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 87324:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4824,1958,8189,1651,4088,4317,9291,8703,9961,4368,1529,586,9774,2888,179], function() { return __webpack_exec__(6777); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);